// extracted by mini-css-extract-plugin
export default {"wrapper":"basic-template_wrapper__nJZXt","inner":"basic-template_inner__+e-q9"};